export const DEFAULT_AUDIENCE_GROUP = 'Affiliate';

export function audienceGroupLabel(profile, isGuest = false) {
  if (isGuest) {
    return 'Guest';
  }

  return profile?.audience?.label || DEFAULT_AUDIENCE_GROUP;
}
